import React, { useEffect, useState } from "react";
import { Breadcrumb, Col, FormGroup, ControlLabel, Checkbox } from "react-bootstrap";
import { LinkContainer } from "react-router-bootstrap";
import { useEventContext, useModuleSettingsContext } from "../../../../context";
import { getEventModuleTheme, updateEventModuleTheme } from "../../../../../api/cp";
import locale from "../../../../locale";
import * as constants from "../constants";
import { availableTypesBackground, availableTypesLogo } from "../models";
import ThemeSettings from "./ThemeSettings";
import FontSettings from "./FontSettings";
import CPSettingUploadImage from "../../../UI/Settings/CPSettingUploadImage";

const BrandingSettings = ({ }) => {
    const { event, setEvent } = useEventContext();
    const { moduleBranding, onSaveBranding } = useModuleSettingsContext();
    const [settings, setSettings] = useState(event?.moduleTheme ?? null);

    useEffect(fetchSettings, []);

    async function fetchSettings() {
        try {
            const response = await getEventModuleTheme(event.eventKey);
            response && setSettings(response);
        } catch (error) {
            console.error(error);
        }
    }

    const handleUpdateEventSettings = async (data) => {
        try {
            const formData = new FormData();
            Object.keys(data).forEach(key => {
                formData.append(key, data[key]);
            });

            if (Object.keys(data)[0] === constants.THEME_COLOR_THEME) {
                const { colorTheme } = data;

                formData.append(
                    constants.THEME_COLOR_BACKGROUND,
                    colorTheme === constants.THEME_DARK ? '16161B' : 'FFFFFF',
                );
                formData.append(
                    constants.THEME_COLOR_TEXT,
                    colorTheme === constants.THEME_DARK ? 'FFFFFF' : '16161B',
                );
            }

            const moduleTheme = await updateEventModuleTheme(event.eventKey, formData);
            setSettings(moduleTheme);
            setEvent(event => ({ ...event, moduleTheme }))
        } catch (error) {
            console.error(error);
        }
    };

    return (
        <section>
            <Breadcrumb>
                <LinkContainer to={`/event/${event.eventPassword}`}>
                    <Breadcrumb.Item>{locale('mainMenu.eventSettings')}</Breadcrumb.Item>
                </LinkContainer>
                <Breadcrumb.Item active>{locale('mainMenu.eventSettings.brandingSettings')}</Breadcrumb.Item>
            </Breadcrumb>

            <Col
                xs={4}
                style={{ marginTop: '20px', paddingLeft: 0 }}
            >
                <FormGroup>
                    <ThemeSettings
                        event={event}
                        setEvent={setEvent}
                        eventTheme={settings}
                        onUpdate={handleUpdateEventSettings}
                    />
                    <FontSettings
                        font={settings.fontFamily}
                        onUpdate={handleUpdateEventSettings}
                    />
                    <CPSettingUploadImage
                        eventImage={settings.logo}
                        title="Логотип для шапки"
                        settingName={constants.THEME_LOGO}
                        tooltipText="Формат файла - .svg или .png"
                        availableTypes={availableTypesLogo}
                        maxImageHeight="40px"
                        onUpdate={handleUpdateEventSettings}
                    />
                    <CPSettingUploadImage
                        eventImage={settings.poster}
                        title="Постер"
                        settingName={constants.THEME_POSTER}
                        tooltipText="Будет отображаться по умолчанию на странице входа, в письмах и в плеере"
                        availableTypes={availableTypesBackground}
                        onUpdate={handleUpdateEventSettings}
                    />
                    <div style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
                        <ControlLabel>Брендинг COMDI</ControlLabel>
                        <Checkbox
                            checked={moduleBranding.showComdiBanner}
                            onChange={(e) => onSaveBranding({ showComdiBanner: e.target.checked })}
                        ></Checkbox>
                    </div>
                </FormGroup>
            </Col>
        </section>
    );
};

export default BrandingSettings;
